import { BrowserSupport } from '@tableau/browser-support';

import { SignInLogo } from '~src/authentication/components/loginSpace/SignInLogo';
import { SignInNoteDescription } from '~src/authentication/components/loginSpace/SignInNoteDescription';

import { LicenseExpirationWarning } from './LicenseExpirationWarning';
import { PreLoginMessage } from './PreLoginMessage';
import React = require('react');


export const LoginPage: React.FunctionComponent = props => {

  return <div data-tb-test-id='login-page-layout' className={'tb-login' + (BrowserSupport.IsTouch() ? ' tb-login-mobile' : '')}>
    <span className={'tb-login-form-container' + (BrowserSupport.IsTouch() ? ' tb-login-form-container-mobile' : '')} role='main'>
      <div>
        <SignInLogo />
      </div>
      {props.children}
    </span>
    <LicenseExpirationWarning />
    <PreLoginMessage />
    <SignInNoteDescription />
  </div>;
};
